<style lang="scss" scoped>
.aside {
  color: #fff;
  height: 100%;
  .info {
    padding: 70px 0 40px;
    text-align: center;
    .logo {
      width: 100px;
    }
    .name {
      font-size: 16px;
    }
  }
}
</style>

<template>
  <el-menu
    default-active="1"
    class="aside"
    background-color="#525A65"
    text-color="#fff"
    active-text-color="#17cfb8"
  >
    <div class="info">
      <img src="../assets/logo2.png" alt="" class="logo">
    </div>
    <el-menu-item index="1">
      <span slot="title">公众号管理</span>
    </el-menu-item>
    <el-menu-item index="2">
      <span slot="title">支付管理</span>
    </el-menu-item>
    <el-menu-item index="3">
      <span slot="title">使用说明</span>
    </el-menu-item>
    <el-menu-item index="4">
      <span slot="title">公告和通知</span>
    </el-menu-item>
  </el-menu>
</template>

<script>
export default {
  components: {},
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
